import { twMerge } from 'tailwind-merge';
import brandMapping from '@/utils/brandMapping';
import { Band } from '@/components/Modules/Band/Band';
import { StructuredText, Image } from 'react-datocms';
import type { Document } from 'datocms-structured-text-utils';
import type { PreFooterFragment } from '@/utils/dato/generated';
import { customNodeRules, renderBlock } from '@/components/structuredText';

const PreFooter = ({
  headerVisibility,
  backgroundColor,
  preFooterImage,
  fullWidth,
  flipped,
  body,
}: PreFooterFragment) => {
  if (body) {
    const background = brandMapping[backgroundColor?.hex] || backgroundColor?.hex || '#71E6C0';
    const Wrapper = fullWidth ? 'div' : Band;

    return (
      <Wrapper className={twMerge('lg:mt-10', fullWidth && 'w-full mb-8')} data-automation="ZA.preFooter">
        <div
          className={twMerge(
            'flex lg:min-h-[300px]',
            flipped ? 'flex-row-reverse' : 'flex-row',
            !fullWidth ? 'rounded-xl' : 'lg:px-15 lg:py-8',
            headerVisibility && 'lg:py-10 lg:mt-[-13rem]',
          )}
          data-automation="ZA.preFooter.row"
          style={{ background }}
        >
          {preFooterImage?.responsiveImage ? (
            <div
              className={twMerge(
                'hidden relative lg:flex items-center lg:w-[40%]',
                !fullWidth && (flipped ? 'rounded-l-xl' : 'rounded-r-xl'),
              )}
            >
              <Image
                data={preFooterImage?.responsiveImage}
                className="block mx-8 z-10 h-auto"
                objectPosition="50% 50%"
                usePlaceholder={false}
              />
            </div>
          ) : null}
          <div
            className={twMerge(
              'w-full h-full flex flex-col text-center px-5',
              'lg:w-[60%] lg:block lg:text-left',
              flipped ? 'lg:px-10' : 'lg:pl-10 lg:pr-6',
            )}
          >
            <div className="py-8 lg:py-12 prose prose-headings:mt-0">
              <StructuredText
                data={{
                  blocks: body.preFooterBodyBlocks,
                  value: body.value as Document,
                }}
                customNodeRules={customNodeRules}
                renderBlock={renderBlock}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
  return null;
};

export default PreFooter;
